import { create } from 'zustand';
import { getAllTrainingVotes, getTraining,
     getTrainingsVotesAdmin, saveTrainingText, getAdminisAbsent, getIfUserVoted } from '../Admin/Api.js';

const useTrainingStore = create((set) => ({
    //User values
    trainingVoteValues: [],
    anwesend: 0,
    abwesend: 0,
    trainingText:"",
    trainingDeadline: "",
    isTrainingCanceled: false,
    voteStatus: -1, // -1 = noch nicht abgestimmt, 0 = abwesend, 1 = anwesend
    checkboxOne: false,
    checkboxTwo: false,

    //Admin values
    trainingsVotesValuesWithNames: [],
    anwesendAdmin: [],
    abwesendAdmin: [],
    //User methods
    getTrainingVotesValues: async () => {
        getAllTrainingVotes()
            .then((data) => {
                let anwesend = 0;
                let abwesend = 0;

                for (let i = 0; i < data.length; i++) {
                    if (data[i] === 1) {
                        anwesend++;
                    } else {
                        abwesend++;
                    }
                }
                set({ anwesend: anwesend, abwesend: abwesend });
            })
            .catch((error) => {
                console.error("Fehler beim Abrufen der Anwesenheitsliste:", error);
            });
    },
    getTraining: async () => {
        getTraining()
            .then((data) => {
                set({ trainingText: data.description, trainingDeadline: data.deadline }); // Setze den Text und die Frist in den Zustand
            })
            .catch((error) => {
                console.error("Fehler beim Abrufen des Admin-Texts:", error);
            });
    },
    getAdminisAbsent: async () => {
        getAdminisAbsent()
            .then((data) => {
                if (data.info === "OK") {
                    set({ isTrainingCanceled: false });
                } else {
                    set({ isTrainingCanceled: true });
                }
            })
            .catch((error) => {
                console.error("Fehler beim Abrufen des Admin-Texts:", error);
            });
    },
    getIfUserVoted: async (name) => {
        getIfUserVoted(name)
            .then((data) => {
                set({ voteStatus: data });
                if (data === 0) {
                    set({ checkboxOne: false, checkboxTwo: true });
                  } 
                  if (data === 1) {
                    set({ checkboxOne: true, checkboxTwo: false });
                  } 
                  if (data === -1) {
                    set({ checkboxOne: false, checkboxTwo: false });
                  }
            })
            .catch((error) => {
                console.error("Fehler beim Abrufen des Abstimmungsstatus:", error);
            });
    },
    setCheckedOne: (checked) => set({ checkboxOne: checked }),
    setCheckedTwo: (checked) => set({ checkboxTwo: checked }),

    //Admin methods
    getTrainingsVotesValuesWithNames: async () => {
        getTrainingsVotesAdmin()
            .then((data) => {
                const anwesend = data.filter(entry => entry[1] === 1).map(entry => entry[0]);
                const abwesend = data.filter(entry => entry[1] === 0).map(entry => entry[0]);
                set({ trainingsVotesValuesWithNames: data, anwesendAdmin: anwesend, abwesendAdmin: abwesend });
            })
            .catch((error) => {
                console.error("Fehler beim Abrufen der Anwesenheitsliste:", error);
            });
    },
    saveTrainingText: async (text) => {
        saveTrainingText(text)
            .then((response) => {
                //console.log("Text erfolgreich gespeichert:", response);
                set({ trainingText: text.text });
            })
            .catch((error) => {
                console.error("Fehler beim Speichern des Textes:", error);
            });
    },
    updateTrainingText: (text) => set({ trainingText: text }), 
}));

export default useTrainingStore;